import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create(
{
    page: {
        flex: 1,
    },

    title: {
        fontSize: 36,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700', 
        marginBottom: 64
    },

    box: {
        padding: 32,
        borderRadius: 24,
        shadowColor: "#0000006b",
        shadowOffset: {
            width: 1,
            height: 0,
        },
        shadowOpacity: 0.35,  
        shadowRadius: 20.32,
        marginBottom: 20
    },

    boxTitle: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700', 
    },

    boxText: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400', 
        marginTop: 38, 
    },

    row: {
        flex: 1,
    }
});